export function getToken() {
    return localStorage.getItem("token");
}

export function setToken(token) {
    localStorage.setItem('token', token);
}

export function removeToken() {
    localStorage.removeItem('token');
}

// Decodifica o `id` do payload do JWT — usado pra escopar flags de localStorage por usuário
// (ex: onboarding dispensado), já que o mesmo navegador pode logar com contas diferentes.
export function getCurrentUserId() {
    const token = getToken();
    if (!token) return null;
    try {
        const payload = token.split('.')[1];
        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        return decoded.id ?? null;
    } catch {
        return null;
    }
}
